"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var data_structures_1 = require("@tableau/data-structures");
function searchToParamValuesMap(search) {
    var paramValuesMap = {};
    if (search.length > 0) {
        if (search[0] === '?') {
            search = search.slice(1);
        }
        var clauses = search.split('&');
        for (var _i = 0, clauses_1 = clauses; _i < clauses_1.length; _i++) {
            var clause = clauses_1[_i];
            var parts = clause.split('=');
            if (parts.length > 0) {
                var param = decodeURIComponent(parts[0]);
                paramValuesMap[param] = parts[1] ? parts[1].split(',').map(decodeURIComponent) : [];
            }
        }
    }
    return paramValuesMap;
}
exports.searchToParamValuesMap = searchToParamValuesMap;
function paramValuesMapToSearch(paramValuesMap) {
    var searchClauses = [];
    for (var param in paramValuesMap) {
        if (paramValuesMap.hasOwnProperty(param)) {
            var encodedParam = encodeURIComponent(param);
            var values = paramValuesMap[param];
            if (values && values.length > 0) {
                searchClauses.push(encodedParam + "=" + values.join(','));
            }
            else {
                searchClauses.push(encodedParam);
            }
        }
    }
    if (searchClauses.length > 1) {
        return "?" + searchClauses.join('&');
    }
    else if (searchClauses.length === 1) {
        return "?" + searchClauses[0];
    }
    else {
        return '';
    }
}
exports.paramValuesMapToSearch = paramValuesMapToSearch;
function addParamValue(paramValuesMap, param, value, encode) {
    if (encode === void 0) { encode = true; }
    var values = paramValuesMap[param];
    if (encode) {
        value = encodeURIComponent(value);
    }
    if (!values) {
        paramValuesMap[param] = [value];
    }
    else {
        if (values.indexOf(value) === -1) {
            paramValuesMap[param] = __spreadArrays(values, [value]);
        }
    }
}
exports.addParamValue = addParamValue;
function removeParamValue(paramValuesMap, param, value) {
    var values = paramValuesMap[param];
    if (values) {
        paramValuesMap[param] = values.filter(function (v) { return v !== value; });
        if (paramValuesMap[param].length === 0) {
            delete paramValuesMap[param];
        }
    }
}
exports.removeParamValue = removeParamValue;
// tslint:disable-next-line:max-line-length
function setParamValues(paramValuesMap, param, values, encode) {
    if (encode === void 0) { encode = true; }
    if (encode) {
        values = values.map(encodeURIComponent);
    }
    paramValuesMap[param] = values;
    if (paramValuesMap[param].length === 0) {
        delete paramValuesMap[param];
    }
}
exports.setParamValues = setParamValues;
function getParamValuesAsSet(search, param) {
    var paramValuesMap = searchToParamValuesMap(search);
    return data_structures_1.stringListToKeySet(paramValuesMap[param]);
}
exports.getParamValuesAsSet = getParamValuesAsSet;
// Only take the first id for the param until Multi-Select Filtering is supported
function getFirstParamValueAsSet(search, param) {
    var firstParamValue = getSingleParamValue(search, param);
    return data_structures_1.stringListToKeySet(firstParamValue ? [firstParamValue] : []);
}
exports.getFirstParamValueAsSet = getFirstParamValueAsSet;
function getSingleParamValue(search, param) {
    var paramValuesMap = searchToParamValuesMap(search);
    return paramValuesMap[param] ? paramValuesMap[param][0] : '';
}
exports.getSingleParamValue = getSingleParamValue;
//# sourceMappingURL=UrlSearchFunctions.js.map